import styles from "./styles/vocal-remover-top-applications.module.scss";
import VocalRemoverApplicationDescription from "@/components/pages/vocal-remover/components/vocal-remover-top-applications/vocal-remover-application-description";
import application1Image from "@/assets/vocal-remover/vocal-remover-top-app-1.webp";
import application2Image from "@/assets/vocal-remover/vocal-remover-top-app-2.webp";
import application3Image from "@/assets/vocal-remover/vocal-remover-top-app-3.webp";
import application4Image from "@/assets/vocal-remover/vocal-remover-top-app-4.webp";

const VocalRemoverTopApplications = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>
        4 Top Applications for <span>Vocal Separator</span>
      </div>
      <div className={styles.top_applications_wrapper}>
        <VocalRemoverApplicationDescription
          image={application1Image.src}
          title={"Karaoke & Sing Practice"}
          description={
            "Using the AI voice remover to magically erase the vocals, you can create the karaoke version of your favorite songs, allowing you to sing your heart out to all your favorites."
          }
          alignment={"left"}
        />
        <VocalRemoverApplicationDescription
          image={application2Image.src}
          title={"Music Production & Remixing"}
          description={
            "By extracting instrumentals from music using this instrumental extractor, you can use the instrumental tracks to make remixes, in your DJ mixes, or in any other music projects you have in mind."
          }
          alignment={"right"}
        />
        <VocalRemoverApplicationDescription
          image={application3Image.src}
          title={"Composition and Sampling"}
          description={
            "After extracting vocals from a song with the help of the acapella extractor, you can use the extracted vocals as material for creating new musical compositions or samples for use in other music production projects."
          }
          alignment={"left"}
        />
        <VocalRemoverApplicationDescription
          image={application4Image.src}
          title={"Audio Editing and Podcast"}
          description={
            "When producing podcasts or crafting audio stories, you can integrate isolated vocals into your narratives, background scores, or soundscapes, thereby enriching the storytelling experience or lending an artistic flair to your creations."
          }
          alignment={"right"}
        />
      </div>
    </div>
  );
};

export default VocalRemoverTopApplications;
